export default __webpack_public_path__ + "locales/nl/EmptyTrashDialog.json?hash=8728c9d0285f2e35e084697ed24a7091";